import {percentageField} from "../../../../services/validate";
import FormBuilder from "../../../../components/form-builder/form-builder";
import * as Yup from "yup";
import TitleWithPopover from "../../../../components/title-with-popover";
import {BaSeGrid, BaSeGridItem, BaSeParagraph} from "@base/react";
import FormInput from "../../../../components/form-builder/form-input";
import shirtLogo from "../../../../assets/images/icons/shirt.svg";
import scissorsLogo from "../../../../assets/images/icons/scissors.svg";
import AccordionModal from "../../../../components/accordion-modal";
import Button from "../../../../components/button/button";

const popoverRates = {
  direction: "right",
  alertSize: 180,
  iconProps: {
    color: "#243342",
    size: 16,
  },
  title: "% Taxas",
  message: "Taxas percentuais de cada item.",
  type: "popover",
};
const popoverRevenue = {
  direction: "left",
  alertSize: 180,
  iconProps: {
    color: "#243342",
    size: 16,
  },
  title: "% da Receita Total",
  message:
    "Informe o percentual das vendas ao qual cada taxa de custo variável se aplica. Por exemplo, se 50% das suas vendas são feitas no cartão de débito, insira 50% na linha correspondente.",
  type: "popover",
};

const variableIndirectCostsValidation = Yup.object({
  cc: Yup.object({
    pdt: percentageField(),
    pdrt: percentageField("Receita Total"),
  }),
  ci: Yup.object({
    pdt: percentageField(),
    pdrt: percentageField("Receita Total"),
  }),
  ou: Yup.object({
    pdt: percentageField(),
    pdrt: percentageField("Receita Total"),
  }),
  tcc: Yup.object({
    pdt: percentageField(),
    pdrt: percentageField("Receita Total"),
  }),
  tcd: Yup.object({
    pdt: percentageField(),
    pdrt: percentageField("Receita Total"),
  }),
})

const VariableIndirectCosts = ({ data, isDisabled, onChange, onSubmit, postCredit = false, lab = false }) => {
  const handleSubmit = (values) => {
    if (onSubmit) {
      onSubmit(values);
    } else {
      onChange(null, values);
    }
  };
  return (
    <div className="step variable-indirect-costs">
      <div className="step--info">
        <h3 className="step--title">
          Custos que mudam de acordo com as vendas, refletindo seu impacto direto no negócio.
        </h3>
        <h5 className="step--subtitle">
          Os campos são opcionais, mas para garantir resultados mais precisos, preencha todas as informações disponíveis.
        </h5>
      </div>
      {!(postCredit || lab) && <AccordionModal title="Exemplos:">
        <div className="example first">
          <img src={shirtLogo} alt="ícone de televisão" />
          <div>
            <BaSeParagraph color="#000">
              <span>Caso 1:</span> Loja de Roupas Virtual
            </BaSeParagraph>
            <ul className="example-list">
              <li>
                <strong>Taxa de cartão de crédito:</strong> 3% sobre cada
                venda parcelada.
              </li>
              <li>
                <strong>Comissão para influenciadores:</strong> 10% sobre cada
                venda realizada via cupom de desconto.
              </li>
              <li>
                <strong>Impostos:</strong> 6% sobre o faturamento.
              </li>
            </ul>
          </div>
        </div>
        <div className="example">
          <img src={scissorsLogo} alt="ícone de talheres" />
          <div>
            <BaSeParagraph color="#000">
              <span>Caso 2:</span> Clínica Estética
            </BaSeParagraph>
            <ul className="example-list">
              <li>
                <strong>Comissão de profissionais:</strong> 30% do valor de
                cada procedimento realizado.
              </li>
              <li>
                <strong>Taxa de uso da plataforma de agendamento:</strong> 5%
                sobre cada serviço pago via app.
              </li>
              <li>
                <strong>Materiais descartáveis utilizados:</strong> custo de
                R$ 10 por atendimento.
              </li>
            </ul>
          </div>
        </div>
      </AccordionModal>}
      <FormBuilder
        initialValues={data}
        validationSchema={variableIndirectCostsValidation}
        onSubmit={handleSubmit}
      >
        <BaSeGrid>
          <BaSeGridItem
            desktop={{
              size: (lab || postCredit) ? 12 : 6,
              startAt: undefined,
            }}
          >
            <TitleWithPopover
              title="Taxa de cartão de débito"
              smallTitle="(média)"
            />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <FormInput
                  id="tcd.pdt"
                  name="tcd.pdt"
                  type="percentage"
                  isDisabled={isDisabled}
                  label="% Taxas"
                  prefix="% "
                  onExternalChange={onChange}
                  maxLength={8}
                  showHelpButton
                  helpButtonProps={popoverRates}
                />
              </BaSeGridItem>
              <BaSeGridItem size={6}>
                <FormInput
                  id="tcd.pdrt"
                  name="tcd.pdrt"
                  type="percentage"
                  isDisabled={isDisabled}
                  label="% da Receita Total"
                  prefix="% "
                  onExternalChange={onChange}
                  maxLength={8}
                  showHelpButton
                  helpButtonProps={popoverRevenue}
                />
              </BaSeGridItem>
            </BaSeGrid>
          </BaSeGridItem>
          <BaSeGridItem
            desktop={{
              size: (lab || postCredit) ? 12 : 6,
              startAt: undefined,
            }}
          >
            <TitleWithPopover
              title="Taxa de cartão de crédito"
              smallTitle="(média)"
            />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <FormInput
                  id="tcc.pdt"
                  name="tcc.pdt"
                  type="percentage"
                  isDisabled={isDisabled}
                  label="% Taxas"
                  prefix="% "
                  onExternalChange={onChange}
                  maxLength={8}
                  showHelpButton
                  helpButtonProps={popoverRates}
                />
              </BaSeGridItem>
              <BaSeGridItem size={6}>
                <FormInput
                  id="tcc.pdrt"
                  name="tcc.pdrt"
                  type="percentage"
                  isDisabled={isDisabled}
                  label="% da Receita Total"
                  prefix="% "
                  onExternalChange={onChange}
                  maxLength={8}
                  showHelpButton
                  helpButtonProps={popoverRevenue}
                />
              </BaSeGridItem>
            </BaSeGrid>
          </BaSeGridItem>
          <BaSeGridItem
            desktop={{
              size: (lab || postCredit) ? 12 : 6,
              startAt: undefined,
            }}
          >
            <TitleWithPopover title="Custos com comissões" />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <FormInput
                  id="cc.pdt"
                  name="cc.pdt"
                  type="percentage"
                  isDisabled={isDisabled}
                  label="% Taxas"
                  prefix="% "
                  onExternalChange={onChange}
                  maxLength={8}
                  showHelpButton
                  helpButtonProps={popoverRates}
                />
              </BaSeGridItem>
              <BaSeGridItem size={6}>
                <FormInput
                  id="cc.pdrt"
                  name="cc.pdrt"
                  type="percentage"
                  isDisabled={isDisabled}
                  label="% da Receita Total"
                  prefix="% "
                  onExternalChange={onChange}
                  maxLength={8}
                  showHelpButton
                  helpButtonProps={popoverRevenue}
                />
              </BaSeGridItem>
            </BaSeGrid>
          </BaSeGridItem>
          <BaSeGridItem
            desktop={{
              size: (lab || postCredit) ? 12 : 6,
              startAt: undefined,
            }}
          >
            <TitleWithPopover title="Custos com impostos" />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <FormInput
                  id="ci.pdt"
                  name="ci.pdt"
                  type="percentage"
                  isDisabled={isDisabled}
                  label="% Taxas"
                  prefix="% "
                  onExternalChange={onChange}
                  maxLength={8}
                  showHelpButton
                  helpButtonProps={popoverRates}
                />
              </BaSeGridItem>
              <BaSeGridItem size={6}>
                <FormInput
                  id="ci.pdrt"
                  name="ci.pdrt"
                  type="percentage"
                  isDisabled={isDisabled}
                  label="% da Receita Total"
                  prefix="% "
                  onExternalChange={onChange}
                  maxLength={8}
                  showHelpButton
                  helpButtonProps={popoverRevenue}
                />
              </BaSeGridItem>
            </BaSeGrid>
          </BaSeGridItem>
          <BaSeGridItem
            desktop={{
              size: (lab || postCredit) ? 12 : 6,
              startAt: undefined,
            }}
          >
            <TitleWithPopover title="Outros custos" />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <FormInput
                  id="ou.pdt"
                  name="ou.pdt"
                  type="percentage"
                  isDisabled={isDisabled}
                  label="% Taxas"
                  prefix="% "
                  onExternalChange={onChange}
                  maxLength={8}
                  showHelpButton
                  helpButtonProps={popoverRates}
                />
              </BaSeGridItem>
              <BaSeGridItem size={6}>
                <FormInput
                  id="ou.pdrt"
                  name="ou.pdrt"
                  type="percentage"
                  isDisabled={isDisabled}
                  label="% da Receita Total"
                  prefix="% "
                  onExternalChange={onChange}
                  maxLength={8}
                  showHelpButton
                  helpButtonProps={popoverRevenue}
                />
              </BaSeGridItem>
            </BaSeGrid>
          </BaSeGridItem>
        </BaSeGrid>
        {postCredit && (
          <div className="send-button">
            <Button type="submit" disabled={isDisabled}>
              Atualizar
            </Button>
          </div>
        )}
      </FormBuilder>
    </div>
  );
};

export default VariableIndirectCosts;
